<template>
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="row mb-3">
          <div class="col-lg-12 d-flex flex-wrap">
            <!--        <div class="mx-1">-->
            <!--          <p class="text-center">Görünüm</p>-->
            <!--          <v-btn-toggle solo mandatory dense>-->
            <!--            <v-tooltip bottom>-->
            <!--              <template v-slot:activator="{ on, attrs }">-->
            <!--                <v-btn-->
            <!--                    v-bind="attrs"-->
            <!--                    v-on="on"-->
            <!--                    @click="dataView = 'ResultTableView'"-->
            <!--                >-->
            <!--                  <i class="bx bx-menu font-size-16"></i>-->
            <!--                </v-btn>-->
            <!--              </template>-->
            <!--              <span>Tablo Görünüm</span>-->
            <!--            </v-tooltip>-->
            <!--            <v-tooltip bottom>-->
            <!--              <template v-slot:activator="{ on, attrs }">-->
            <!--                <v-btn-->
            <!--                    v-bind="attrs"-->
            <!--                    v-on="on"-->
            <!--                    @click="dataView = 'ResultCardView'"-->
            <!--                >-->
            <!--                  <i class="bx bx-card font-size-16"></i>-->
            <!--                </v-btn>-->
            <!--              </template>-->
            <!--              <span>Kart Görünüm</span>-->
            <!--            </v-tooltip>-->
            <!--          </v-btn-toggle>-->
            <!--        </div>-->
            <div class="mx-1">
              <p class="text-center">Gösterilen Kayıt Sayısı</p>
              <v-btn-toggle mandatory solo dense @change="fetchData">
                <v-btn @click="perPage = 10"> 10</v-btn>
                <v-btn @click="perPage = 20"> 20</v-btn>
                <v-btn @click="perPage = 30"> 30</v-btn>
                <v-btn @click="perPage = 50"> 50</v-btn>
                <v-btn @click="perPage = 100"> 100</v-btn>
              </v-btn-toggle>
            </div>
            <div class="mx-1 align-self-end">
              <TableColumnSelect
                  class="mb-1"
                  v-if="!currentListLoading"
                  :cols="currentListHeaders"
                  @saveColData="e => editTableColumns(e)"
              >
              </TableColumnSelect>
            </div>
            <div class="ms-auto">
              <v-text-field
                  v-model="searchText"
                  class="mt-5 pt-3"
                  outlined
                  rounded
                  dense
                  placeholder="Arama Yapın..."
                  clearable
                  hide-details
                  append-icon="mdi-magnify"
                  @click:append="fetchData()"
                  @keydown.enter="fetchData()"
              ></v-text-field>
            </div>
          </div>
        </div>
        <div class="row">
          <KeepAlive>
            <component :is="dataView" v-bind="dynamicProps"></component>
          </KeepAlive>
        </div>
        <!-- end row -->
        <div class="row">
          <div class="col-lg-12 mb-5">
            <v-pagination
                v-model="currentPage"
                class="my-4"
                :length="currentListMetaData.totalPages"
                :total-visible="10"
            ></v-pagination>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import ResultTableView from "@/components/current/results/ResultsTableView.vue";
import ResultCardView from "@/components/current/results/ResultsCardView.vue";
import {mapState, mapActions, mapMutations} from "vuex";
import TableColumnSelect from "@/components/shared/TableColumnSelect.vue";
import ResultsMixin from "@/mixins/ResultsMixin";

export default {
  components: {
    TableColumnSelect,
    ResultTableView,
    ResultCardView
  },
  mixins: [ResultsMixin],
  computed: {
    ...mapState("current", ["currentList", "currentListMetaData", "currentListHeaders", "currentListLoading"]),
    ...mapState("auth", ["user"]),
    dynamicProps: function () {
      if (this.dataView === "ResultTableView") {
        return {perPage: this.perPage, currentPage: this.currentPage};
      } else return {};
    }
  },
  data() {
    return {
      dataView: "ResultTableView",
    };
  },
  methods: {
    ...mapMutations("current", ["setCurrentListHeaders"]),
    ...mapActions("current", ["fetchCurrentList"]),

    async fetchData() {
      await this.fetchCurrentList({
        params: {
          userId: this.user.UserId,
          pageNumber: this.currentPage,
          pageSize: this.perPage,
          ...(this.user.RoleGroupId == "2" || this.user.RoleGroupId == 2 ? true : false) && {salesPersonCode: this.user.SalesPersonCode},
          ...(this.searchText == "" || this.searchText == null ? false : true) && {searchText: this.searchText}
        },
        body: {}
      });
      this.updateUrl();
    },

    editTableColumns(cols = []) {
      this.setCurrentListHeaders(cols);
    },
  },
};
</script>